import React from 'react';
import styled from 'styled-components';
import countries from './countries';

const Wrapper = styled.div`
  display: flex;
  border: 1px solid ${({ $error, theme }) => ($error ? '#ef4444' : theme.colors.border.main)};
  border-radius: 10px;
  overflow: hidden;
  background-color: ${p => p.theme.colors.background.paper};
  transition: all 0.2s;
  &:focus-within {
    border-color: ${({ $error, theme }) => ($error ? '#ef4444' : theme.colors.text.primary)};
    box-shadow: 0 0 0 3px ${({ $error, theme }) => ($error ? 'rgba(239,68,68,0.1)' : theme.colors.background.selected)};
  }
`;

const DialSelect = styled.select`
  flex-shrink: 0;
  width: 110px;
  padding: 14px 8px 14px 12px;
  border: none;
  border-right: 1px solid ${p => p.theme.colors.border.main};
  background-color: ${p => p.theme.colors.background.main};
  color: ${p => p.theme.colors.text.primary};
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 6px center;
  background-size: 12px;
  padding-right: 22px;
  &:focus {
    outline: none;
  }
`;

const NumberInput = styled.input`
  flex: 1;
  padding: 14px 16px;
  border: none;
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  color: ${p => p.theme.colors.text.primary};
  background-color: transparent;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${p => p.theme.colors.text.disabled};
  }
`;

export const PhoneInput = ({ dialCodeName, numberName, register, errors, index, arrayName, placeholder = '555 000 0000' }) => {
    // Determine if there's an error for this field, handling nested array paths
    let hasError = false;
    if (arrayName !== undefined && index !== undefined) {
        // Handle array field: errors[arrayName][index][fieldName]
        const fieldNameDial = dialCodeName.split('.').pop();
        const fieldNameNumber = numberName.split('.').pop();
        hasError = !!(errors?.[arrayName]?.[index]?.[fieldNameDial] || errors?.[arrayName]?.[index]?.[fieldNameNumber]);
    } else {
        // Handle simple field: errors[fieldName]
        hasError = !!(errors?.[dialCodeName] || errors?.[numberName]);
    }

    return (
        <Wrapper $error={hasError}>
            <DialSelect {...register(dialCodeName)}>
                {countries.map(c => (
                    <option key={c.code} value={c.dialCode}>
                        {c.flag} {c.dialCode}
                    </option>
                ))}
            </DialSelect>
            <NumberInput
                type="tel"
                {...register(numberName)}
                placeholder={placeholder}
            />
        </Wrapper>
    );
};

export default PhoneInput;
